import { EMPTY } from "./emptyValue";

export type Granularity = {
  id: string;
  text: string;
  minDays: number;
  maxDays?: number;
};

export const FULL_FORMAT_GRANULARITIES: Granularity[] = [
  { id: "day", text: "Giornaliero", maxDays: 32, minDays: 1 },
  { id: "week", text: "Settimanale (Lun-Dom)", maxDays: 186, minDays: 8 },
  { id: "sweek", text: "Settimanale (Dom-Sab)", maxDays: 186, minDays: 8 },
  { id: "month", text: "Mensile", maxDays: 366, minDays: 30 },
  { id: "year", text: "Annuale", maxDays: 10000, minDays: 365 },
];

export const RAW_FORMAT_GRANULARITIES: Granularity[] = [
  { id: "day", text: "Giornaliero", maxDays: 32, minDays: 1 },
  { id: "week", text: "Settimanale (Lun-Dom)", minDays: 8 },
  { id: "sweek", text: "Settimanale (Dom-Sab)", minDays: 8 },
  { id: "month", text: "Mensile", minDays: 30 },
  { id: "year", text: "Annuale", minDays: 365 },
];

export const AUDITEL_TARGET_REQUIRED_MESSAGE =
  "Seleziona un target Auditel: è obbligatorio per i report GRP e Contatti.";

export function granularityLabelFor(id: string | null): string {
  if (!id) return EMPTY;
  return FULL_FORMAT_GRANULARITIES.find((g) => g.id === id)?.text ?? id;
}
